// https://vuex.vuejs.org/en/mutations.html

export default {
  authUser(state, userData) {
    // state.idToken = userData.idToken,
    ((state.idToken = userData.token), (state.userId = userData.userId));
    state.currentUser = userData.currentUser;
  },
  storeToken(state, token) {
    state.idToken = token;
  },
  storeUser(state, user) {
    state.user = user;
  },
  setCurrentUser(state, currentUser) {
    state.currentUser = currentUser;
  },
  setPublicRoute(state, publicRoute) {
    state.publicRoute = publicRoute;
  },
  clearAuthData(state) {
    state.idToken = null;
    state.userId = null;
    state.user = null;
    state.loading = false;
    state.currentUser = null;
    // state.sales = state.sales.getDefaultState()
    // state.cs = state.cs.getDefaultState()
    state.items = [];
    state.leads = [];
    ((state.consumer_units = []),
      (state.pagination = {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: "created_at",
        totalItems: 0,
        rowsPerPageItems: [5, 10, 25, 50, 100],
      }),
      (state.users = []),
      (state.config = {
        users: {
          total: 0,
          ativos: 0,
          inativos: 0,
        },
        consumer_units: {
          total: 0,
          ativos: 0,
          inativos: 0,
        },
      }));
  },
  setConfig(state, config) {
    state.config = config;
  },
  setGroupList(state, groupList) {
    state.groupList = groupList;
  },
  setPagination(state, payload) {
    state.pagination = payload;
  },
  _setConsumerUnits(state, items) {
    state.consumer_units = items;
  },
  _setItems(state, { items, total }) {
    state.items = items;
    state.pagination.totalItems = total;
    // this.$set(state.pagination, 'totalItems', totalItems)
  },
  setPowerPlants(state, powerplants) {
    state.powerplants = powerplants;
  },
  set_cancel_parcel(state, cancel_parcel) {
    state.permissions.cancel_parcel = cancel_parcel;
  },
  set_cancel_uc(state, cancel_uc) {
    state.permissions.cancel_uc = cancel_uc;
  },
  set_cancel_user(state, cancel_user) {
    state.permissions.cancel_user = cancel_user;
  },
  set_change_abono(state, change_abono) {
    state.permissions.change_abono = change_abono;
  },
  set_change_bonus_uc(state, change_bonus_uc) {
    state.permissions.change_bonus_uc = change_bonus_uc;
  },
  set_change_additional_balance_uc(state, change_additional_balance_uc) {
    state.permissions.change_additional_balance_uc =
      change_additional_balance_uc;
  },
  set_change_due_date(state, change_due_date) {
    state.permissions.change_due_date = change_due_date;
  },
  set_change_due_date_installment(state, change_due_date_installment) {
    state.permissions.change_due_date_installment = change_due_date_installment;
  },
  set_change_email(state, change_email) {
    state.permissions.change_email = change_email;
  },
  set_decrypt_login(state, decrypt_login) {
    state.permissions.decrypt_login = decrypt_login;
  },
  set_download_bill(state, download_bill) {
    state.permissions.download_bill = download_bill;
  },
  set_edit_customer(state, edit_customer) {
    state.permissions.edit_customer = edit_customer;
  },
  set_edit_cpf_cnpj(state, edit_cpf_cnpj) {
    state.permissions.edit_cpf_cnpj = edit_cpf_cnpj;
  },
  set_faturar(state, faturar) {
    state.permissions.faturar = faturar;
  },
  set_forced_canceling(state, forced_canceling) {
    state.permissions.forced_canceling = forced_canceling;
  },
  set_forced_cancellation(state, forced_cancellation) {
    state.permissions.forced_cancellation = forced_cancellation;
  },
  set_inform_payment(state, inform_payment) {
    state.permissions.inform_payment = inform_payment;
  },
  set_invoice_by_spreadsheet(state, invoice_by_spreadsheet) {
    state.permissions.invoice_by_spreadsheet = invoice_by_spreadsheet;
  },
  set_invoice_by_xml(state, invoice_by_xml) {
    state.permissions.invoice_by_xml = invoice_by_xml;
  },
  set_parcel(state, parcel) {
    state.permissions.parcel = parcel;
  },
  set_payoff_parcel(state, payoff_parcel) {
    state.permissions.payoff_parcel = payoff_parcel;
  },
  set_reactivate_uc(state, reactivate_uc) {
    state.permissions.reactivate_uc = reactivate_uc;
  },
  set_reactivate_user(state, reactivate_user) {
    state.permissions.reactivate_user = reactivate_user;
  },
  set_referral(state, referral) {
    state.permissions.referral = referral;
  },
  set_remove_negativations(state, remove_negativations) {
    state.permissions.remove_negativations = remove_negativations;
  },
  set_reparcel(state, reparcel) {
    state.permissions.reparcel = reparcel;
  },
  set_reprocess_billing(state, reprocess_billing) {
    state.permissions.reprocess_billing = reprocess_billing;
  },
  set_resend_bill(state, resend_bill) {
    state.permissions.resend_bill = resend_bill;
  },
  set_upload_bill(state, upload_bill) {
    state.permissions.upload_bill = upload_bill;
  },
  set_uc_under_analysis(state, uc_under_analysis) {
    state.permissions.uc_under_analysis = uc_under_analysis;
  },
  set_force_uc_cancellation(state, force_uc_cancellation) {
    state.permissions.force_uc_cancellation = force_uc_cancellation;
  },
  set_change_plan_uc(state, change_plan_uc) {
    state.permissions.change_plan_uc = change_plan_uc;
  },
  set_change_uc_id(state, change_uc_id) {
    state.permissions.change_uc_id = change_uc_id;
  },
  set_regenerate_billing(state, regenerate_billing) {
    state.permissions.regenerate_billing = regenerate_billing;
  },
  set_choose_seller_in_sale(state, choose_seller_in_sale) {
    state.permissions.choose_seller_in_sale = choose_seller_in_sale;
  },
  set_without_balance(state, without_balance) {
    state.permissions.without_balance = without_balance;
  },
  set_generate_contract(state, generate_contract) {
    state.permissions.generate_contract = generate_contract;
  },
  set_charge_provisioned(state, charge_provisioned) {
    state.permissions.charge_provisioned = charge_provisioned;
  },
  set_change_seller(state, change_seller) {
    state.permissions.change_seller = change_seller;
  },
  set_change_special_billing_due_date(state, change_special_billing_due_date) {
    state.permissions.change_special_billing_due_date =
      change_special_billing_due_date;
  },
  set_delete_contract(state, delete_contract) {
    state.permissions.delete_contract = delete_contract;
  },
};
